module.exports = __webpack_public_path__ + "static/demolition-barn-216f69e2fc756cc1f057842ef3fe4a0c.png";